import {
    MDBBtn,
    MDBIcon,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog
} from 'mdb-react-ui-kit';

import LoginRegister from './LoginRegister';

import PropTypes from 'prop-types';
import React, { useContext,useEffect } from "react";
import { UserProfileContext } from '../context/UserProfileProvider';
export default function LoginModal({  toggleShowStartButtons  , anonymousUser}) {
    const { isLoginRequired, setIsLoginRequired} = useContext(UserProfileContext);
    useEffect(() => {
        localStorage.setItem("isPricing", window.location.host.includes("x-trk"));
       },[])
    return (
        <>
             <MDBBtn  color="none"   onClick={() => setIsLoginRequired(true)} floating href='#'>
      
             {/* <MDBIcon size='2x' far icon="user" style={{ color: '#c61118' }}/> */}
             <img  src='https://opengrit.com/images/avatar'   className="rounded" style={{ height: 35 ,color: '#c61118'}}  alt="" />
            </MDBBtn>
            <MDBModal tabIndex={-1} staticBackdrop={true} closeOnEsc={true} nonInvasive={true}
                animationDirection='right' onClose= {()=> setIsLoginRequired(false)}
                open={isLoginRequired}>
                <MDBModalDialog size='xl'>
                    <MDBModalContent style={{ height: '0vh' }}>
                        <MDBModalBody >
                            <LoginRegister
                           anonymousUser={anonymousUser}
                                toggleLoginModal={isLoginRequired}
                               />
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </>
    );
}
LoginModal.propTypes = {
   
    toggleShowStartButtons: PropTypes.func,
   
    anonymousUser:PropTypes.string,
  

};